<template>
  <div>
    <ion-img
      :src="content.image"
      class="w-full h-auto object-cover w-full overflow-hidden rounded-12"
    />
    <h6 class="font-unineue-bold text-20">
      {{ content.title }}
    </h6>
    <div class="flex flex-col">
      <div
        class="font-helvetica text-mid-dark-grey maintext spacing-1 mb-4"
        v-html="content.mainText"
      />

      <div
        class="font-helvetica text-mid-dark-grey subtext spacing-1"
        v-html="content.subText"
      />
    </div>

    <div v-if="content.features?.length">
      <detail-section
        v-for="feature in content.features"
        :key="feature.anchor"
        noPadding
        :id="feature?.anchor"
      >
        <h6 class="font-unineue-bold text-20 mb-4">{{ feature.title }}</h6>
        <ion-img
          :src="feature.image"
          class="w-full h-full object-cover w-full overflow-hidden rounded-12 mb-4"
        />
        <div
          class="description font-unineue-book"
          v-html="feature.description"
        />
      </detail-section>
    </div>
  </div>
</template>

<script lang="ts">
import DetailSection from "@/components/DetailSection.vue";
import { IonImg } from "@ionic/vue";
import { defineComponent } from "vue";
import type { PropType } from "vue";

export default defineComponent({
  name: "ProductsDetailDepthItem",
  components: {
    IonImg,
    DetailSection,
  },
  props: {
    content: {
      type: Object as PropType<{
        image: string;
        title: string;
        mainText: string;
        subText: string;
        features: {
          title: string;
          image: string;
          description: string;
          anchor: string;
        }[];
      }>,
      required: true,
    },
  },
  data() {
    return {
      count: 1,
    };
  },
  mounted() {},
});
</script>
<style>
.maintext p {
  font-size: 24px;
  line-height: 28px;
}
.subtext p {
  font-size: 16px;
  line-height: 20px;
}

.description p {
  font-size: 16px;
  line-height: 24px;
}

.description > p + p,
.maintext > p + p,
.subtext > p + p {
  margin-top: 1.5rem;
}
</style>
